import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import "./Cards.css"; // Import your separate CSS file for animations

// Import images
import discoveryImage from "../Assets/images/discovery.png";
import workgroupImage from "../Assets/images/workgroup.png";
import addimage from "../Assets/images/add.png";

function Cards() {
  const cardRefs = {
    card1: useRef(null),
    card2: useRef(null),
    card3: useRef(null),
  };

  useEffect(() => {
    const cards = Object.values(cardRefs);

    const handleScroll = () => {
      cards.forEach((card) => {
        if (card.current && isInViewport(card.current)) {
          card.current.classList.add("animate-card");
        }
      });
    };

    const isInViewport = (element) => {
      const rect = element.getBoundingClientRect();
      return (
        rect.top <= (window.innerHeight || document.documentElement.clientHeight) * 0.8
      );
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // Trigger animation on initial load

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className="py-16 md:py-24 bg-[#fffaf5]">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center mb-16 md:20 max-w-3xl mx-auto px-4">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-purple-50 text-purple-600 rounded-full text-sm font-bold mb-6 border border-purple-100 shadow-sm">
            <span>✨</span> Features
          </div>
          <h2 className="text-3xl md:text-5xl font-black text-black mb-6 tracking-tight leading-tight">
            What Braccet Offers
          </h2>
          <p className="text-gray-500 text-lg md:text-xl font-medium">
            Everything you need to scale your content and partnerships in one intuitive platform.
          </p>
        </div>        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10 px-2 lg:px-12">
          {/* Card 1 */}
          <div
            ref={cardRefs.card1}
            className="group relative overflow-hidden bg-white rounded-[2.5rem] md:rounded-[3rem] border border-gray-100 p-8 md:p-12 transition-all duration-500 hover:shadow-[0_40px_100px_-20px_rgba(59,130,246,0.15)] hover:-translate-y-3 opacity-0 translate-y-8"
          >
            <div className="absolute top-0 right-0 w-40 h-40 bg-blue-50/60 rounded-bl-[6rem] -mr-12 -mt-12 transition-transform duration-700 group-hover:scale-125" />
            <div className="relative mb-10 w-20 h-20 bg-blue-600 rounded-3xl flex items-center justify-center p-5 shadow-lg group-hover:scale-110 group-hover:rotate-6 transition-all duration-500">
              <img
                src={discoveryImage}
                alt="Discover"
                className="w-full h-full object-contain brightness-0 invert contrast-125"
              />
            </div>
            <h3 className="text-2xl font-black text-black mb-5 group-hover:text-blue-600 transition-colors">Discover</h3>
            <p className="text-gray-500 text-lg leading-relaxed font-semibold">
              Explore a curated ecosystem of premium brands and creative masters ready to connect and collaborate.
            </p>
            <Link to="/onboarding" className="mt-10 flex items-center gap-2 text-blue-600 font-black group-hover:translate-x-3 transition-transform cursor-pointer uppercase text-xs tracking-widest no-underline">
              Explore Network <span>→</span>
            </Link>
          </div>

          {/* Card 2 */}
          <div
            ref={cardRefs.card2}
            className="group relative overflow-hidden bg-gray-950 rounded-[2.5rem] md:rounded-[3rem] p-8 md:p-12 transition-all duration-500 hover:shadow-[0_40px_100px_-20px_rgba(0,0,0,0.3)] hover:-translate-y-3 opacity-0 translate-y-8"
          >
            <div className="absolute top-0 right-0 w-40 h-40 bg-white/5 rounded-bl-[6rem] -mr-12 -mt-12 transition-transform duration-700 group-hover:scale-125" />
            <div className="relative mb-10 w-20 h-20 bg-white rounded-3xl flex items-center justify-center p-5 shadow-xl group-hover:scale-110 group-hover:-rotate-6 transition-all duration-500">
              <img
                src={workgroupImage}
                alt="Collaborate"
                className="w-full h-full object-contain contrast-150 brightness-110"
              />
            </div>
            <h3 className="text-2xl font-black text-white mb-5">Collaborate</h3>
            <p className="text-gray-400 text-lg leading-relaxed font-semibold">
              Forge powerful partnerships and produce viral-worthy content through our seamless communication tools.
            </p>
            <Link to="/onboarding" className="mt-10 flex items-center gap-2 text-white font-black group-hover:translate-x-3 transition-transform cursor-pointer uppercase text-xs tracking-widest no-underline">
              Join Workspace <span>→</span>
            </Link>
          </div>

          {/* Card 3 */}
          <div
            ref={cardRefs.card3}
            className="group relative overflow-hidden bg-white rounded-[2.5rem] md:rounded-[3rem] border border-gray-100 p-8 md:p-12 transition-all duration-500 hover:shadow-[0_40px_100px_-20px_rgba(139,92,246,0.15)] hover:-translate-y-3 opacity-0 translate-y-8"
          >
            <div className="absolute top-0 right-0 w-40 h-40 bg-purple-50/60 rounded-bl-[6rem] -mr-12 -mt-12 transition-transform duration-700 group-hover:scale-125" />
            <div className="relative mb-10 w-20 h-20 bg-purple-600 rounded-3xl flex items-center justify-center p-5 shadow-lg group-hover:scale-110 group-hover:rotate-6 transition-all duration-500">
              <img
                src={addimage}
                alt="Create"
                className="w-full h-full object-contain brightness-0 invert contrast-125"
              />
            </div>
            <h3 className="text-2xl font-black text-black mb-5 group-hover:text-purple-600 transition-colors">Create</h3>
            <p className="text-gray-500 text-lg leading-relaxed font-semibold">
              Unleash your creative potential with campaigns that captivate audiences and skyrocket your brand presence.
            </p>
            <Link to="/onboarding" className="mt-10 flex items-center gap-2 text-purple-600 font-black group-hover:translate-x-3 transition-transform cursor-pointer uppercase text-xs tracking-widest no-underline">
              Start Campaign <span>→</span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Cards;
